import React from "react";
import {
    deleteEMContract,
    getFeConfig,
    uploadEMContract,
    visualizeWithFilters,
    replaceEMContract,
    submitRefTableData,
    fetchEMContract,
    fetchPreviousEMContract,
    updateEmContract
} from "../api/api";
import {MerchantInfoContext} from "./Editor";
import {Button, Modal, notification, Upload, Space, Tag} from "antd";
import {DeleteOutlined, InboxOutlined, PlusOutlined, UploadOutlined, EditOutlined, InfoCircleOutlined, CloudDownloadOutlined} from "@ant-design/icons";
import {unstable_batchedUpdates} from "react-dom";
import {Form} from "@q4us-sw/q4us-ui";
import {CustomFormInput} from "@q4us-sw/q4us-ui/lib/Form";
import moment from 'moment';


export const DocumentItem = ({config, data: row = {}, schema}) => {
    const [open,setOpen] = React.useState(false)
    const [cfg, setCfg] = React.useState(false)
    const docs = row['em_contract_document']

    const load = async () => {
        const {data: {rows} = {}} = await getFeConfig(config.name) || {}
        setCfg(rows)
    }
    React.useEffect(() => {
        load().catch(e => {
            notification.warn({message: e.message});
        });
    }, []);

    return <MerchantInfoContext.Consumer>
        {
            em => <div className={`info-group`}>
                {docs && docs.map((o, i)=>{
                    return <table>
                        <thead>
                        <tr>
                            <td colSpan={3}>
                                <div className={`flexbox-container`}>
                                    <div className={`doc-title`}>{`${config.title} #${i + 1}`} </div>
                                    <div className={`doc-button`}>
                                        <Button icon={<DeleteOutlined/>} onClick={async () => {
                                            const res = await deleteEMContract(o['id'], em?.data?.id);
                                            if(res.status === 200){
                                                const {data: {rows: [r] = []} = {}} = await visualizeWithFilters('em', [{
                                                    key: 'id',
                                                    value: em?.data?.id
                                                }]) || {}
                                                if (r)
                                                    em?.setData(r)
                                                notification.success({message: `File [${o['document_name']}] deleted`})
                                                return true
                                            }else{
                                                notification.error({message: `File delete failed`})
                                            }
                                        }}/>
                                    </div>

                                </div>
                            </td>
                        </tr>
                        </thead>
                        {cfg && cfg.map((w)=>{
                            return <tr>
                                    <td className={`info-label`}><div className={`cell`}>{w?.title}</div></td>
                                    <td> <div className={`cell data-cell`}>
                                        {w.name !== 'file'&& w.name !== 'date_of_upload' && w.name !== 'date_of_change'&&o[w.name]}
                                        {w.name === 'date_of_upload' && o[w.name] && moment(o[w.name]).format("YYYY-MM-DD")}
                                        {w.name === 'date_of_change' && o[w.name] && moment(o[w.name]).format("YYYY-MM-DD")}

                                        {w.name === 'file' && <Space direction={'horizontal'}>
                                            {o['isreplaced'] && <Button icon={<CloudDownloadOutlined/>} style={{color: 'grey'}} onClick={async ()=>{
                                                await fetchPreviousEMContract(o['id'], em?.data?.id )
                                            }}/>}
                                            <Button icon={<CloudDownloadOutlined/>} style={{color: 'green'}} onClick={async ()=>{
                                                await fetchEMContract(o['id'], o['name'])
                                            }}/>
                                        </Space>
                                        }
                                    </div></td>
                                    <td> <div className={`cell data-cell`}>
                                        {w.editable&&<EditComponent row={o} config={w} />}
                                        {w.name === 'file'&&<ReplaceComponent row={o} />}
                                    </div></td>
                                </tr>
                        })
                        }
                    </table>
                })}
                <Button
                    type="dashed"
                    block
                    className={`add-new-record-btn`}
                    onClick={()=>setOpen(true)}
                >
                    <PlusOutlined/>
                    {`Add New ${config.title}`}
                </Button>
                <Modal
                    onCancel={() => setOpen(false)}
                    footer={null}
                    closable={true}
                    title={'Add General Contract Document'}
                    visible={open}
                >
                    <ContractForm onCancel={()=>setOpen(false)} onSubmit={()=> {
                        setOpen(false)
                        return true;
                    }}/>
                </Modal>
            </div>
        }
    </MerchantInfoContext.Consumer>
}

export const ContractForm = ({onSubmit, onCancel, documents, setDocuments}) => {

    return <MerchantInfoContext.Consumer>
        {
            em => <Form
                maxHeight={`60vh`}
                schema={`contract_document`}

                config={async (schema) => {
                    const {data: {rows = []} = {}} = await getFeConfig(schema) || {}
                    return rows;
                }}

                visibilityValidator={(schema, {name}) => {
                    if (schema === 'contract_document') {
                        return name !== 'sort_number'&& name !== 'date_of_upload' && name !== 'date_of_change'
                    }
                    return true;
                }}
                overrideComponent={(schema, element)=>{
                    if(schema === 'contract_document'){
                        if(element.name === 'file'){
                            return <UploadItem key={`file`}/>
                        }
                    }
                }}

                rejected={()=>onCancel()}
                submit={async (values) => {
                    const {file, document_name} = values
                    const formData = new FormData();
                    formData.append('em_id', em?.data?.id);
                    formData.append('document_name', document_name);
                    formData.append('data', file);

                    const res = await uploadEMContract(formData)
                    const {status} = res
                    if(status === 200){
                        notification.success({message: `File uploaded successfully`})
                        const {data: {rows: [r] = []} = {}} = await visualizeWithFilters('em', [{
                            key: 'id',
                            value: em?.data?.id
                        }]) || {}

                        if (r)
                            em?.setData(r)
                    }else{
                        notification.error({message: `File upload failed`})
                    }
                    return await onSubmit()
                }}/>
        }
    </MerchantInfoContext.Consumer>

};

const UploadItem = ({value, onChange})=>{

    return <Upload.Dragger
        maxCount={1}
        fileList={value ? [value]: []}
        progress={{
            showInfo: false
        }}
        onRemove={()=>onChange(undefined)}
        customRequest={(opt)=>{
            onChange(opt.file)
            opt.onSuccess()
        }}>
        <p className="ant-upload-drag-icon">
            <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag file to this area to upload</p>
    </Upload.Dragger>
}

const ReplaceComponent = (props) => {
    const {row, index} = props;
    return <MerchantInfoContext.Consumer>
        { doc => <Space direction={'horizontal'} key={index}>
            <Upload
                progress={{
                    showInfo: false
                }}
                fileList={[]}
                customRequest={async ({ file, onSuccess })=>{
                    const formData = new FormData();
                    formData.append('em_id', doc?.data?.id);
                    formData.append('id', row.id);
                    formData.append('data', file);

                    const res = await replaceEMContract(formData);
                    const {status} = res;
                    if(status === 200){
                        notification.success({message: `File replaced successfully`})
                        const {data: {rows: [r] = []} = {}} = await visualizeWithFilters('em', [{
                            key: 'id',
                            value: doc?.data?.id
                        }]) || {}
                        if (r)
                            doc?.setData(r)
                    }
                }}
            >
                <Button icon={<UploadOutlined />}>Replace</Button>
            </Upload>
        </Space>}
    </MerchantInfoContext.Consumer>
}

const EditComponent = (props) => {
    const {row, config, index} = props;
    const [visible, setVisible] = React.useState(false)
    const [value, setValue] = React.useState()

    return <Space direction={'horizontal'} key={index}>
            <Button
                type="link"
                icon={<EditOutlined/>}
                onClick={e => {
                    setVisible(true)
                }}
            />
        {visible && <Modal
            closable={false}
            title={null}
            visible={visible}
            footer={null}
            className={"ant-modal ant-modal-confirm ant-modal-confirm-confirm"}
        >
            <div className="ant-modal-confirm-body-wrapper">
                <div className="ant-modal-confirm-body">
                    <InfoCircleOutlined/>
                    <span
                        className="ant-modal-confirm-title">{`Change [${config?.title}]`}</span>
                    <div className="ant-modal-confirm-content">
                        <div className={`em-editor-dialog`}>
                            <div className={`title`}>{config?.title}</div>
                            <div className={`edit-cell`}>
                                <CustomFormInput
                                    schema={'em'}
                                    type={config?.type}
                                    name={config?.name}
                                    title={config?.title}
                                    value={value}
                                    onChange={e => {
                                        setValue(e)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ant-modal-confirm-btns em-editor-btn-wrap">
                    <MerchantInfoContext.Consumer>
                        {em => <Button className="em-editor-approve-btn"
                                       onClick={async () => {
                                           switch (config?.name){
                                               case "document_name":
                                                   await updateEmContract({
                                                       id: row.id,
                                                       document_name : value || null,
                                                       em_id : em?.data?.id
                                                   }, 'em_contract_document');
                                               case "sort_number" :
                                                   await submitRefTableData({
                                                       id: row.id,
                                                       [config?.name]: value || null
                                                   }, 'em_contract_document', {emptyStringAllowed: true});
                                           }
                                           await submitRefTableData({
                                               id: row.id,
                                               [config?.name]: value || null
                                           }, 'em_contract_document', {emptyStringAllowed: true});

                                           const {data: {rows: [r] = []} = {}} = await visualizeWithFilters('em', [{
                                               key: 'id',
                                               value: em?.data?.id
                                           }]) || {}
                                           if (r)
                                               em?.setData(r)

                                           unstable_batchedUpdates(() => {
                                               setVisible(false)
                                               setValue(undefined)
                                           })
                                       }}>Yes</Button>}
                    </MerchantInfoContext.Consumer>
                    <Button className={`ant-btn-dangerous`} onClick={() => {
                            setVisible(false)
                    }}>No</Button>

                </div>
            </div>
        </Modal>}

    </Space>
}